import axios from 'axios';
export { apiErrorMessage } from './alianzasApi';

const api = axios.create({
  baseURL: `${(process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '')}/servicios-profesionales/reporte-semanal`,
  timeout: 45000,
});
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use((response) => response, (error) => {
  if (error?.response?.status === 401) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    if (window.location.pathname !== '/login') window.location.assign('/login');
  }
  return Promise.reject(error);
});

export const weeklyReportApi = {
  draft: () => api.get('/borrador').then((r) => r.data),
  create: (kind, data, revision) => api.post(`/borrador/${kind}`, data, { params: { revision } }).then((r) => r.data),
  update: (kind, id, data, revision) => api.put(`/borrador/${kind}/${id}`, data, { params: { revision } }).then((r) => r.data),
  archive: (kind, id, revision, restore = false) => api.post(
    `/borrador/${kind}/${id}/${restore ? 'restaurar' : 'archivar'}`, { revision },
  ).then((r) => r.data),
  cuts: (offset = 0) => api.get('/cortes', { params: { limit: 50, offset } }).then((r) => r.data),
  cut: (id) => api.get(`/cortes/${id}`).then((r) => r.data),
  publish: (data) => api.post('/cortes', data).then((r) => r.data),
};
